import React from 'react'
import { Container, Image } from 'react-bootstrap'

import { Link } from 'react-router-dom'
import { PageDefault, PageDefaultProfile } from '../Constants'
import imgBanner from '../images/login_page.png'

export default function NotFoundPage() {
  return (
    <Container fluid>
      <div className='row'>
        <div className='col-lg-12 mx-auto text-center mt-5'>
          <div>
            <h1 className='text-primary'>404 - Not Found!</h1>
            <p className='fw-light'>
              We're sorry, the page you requested could not be found Please go back to the homepage
            </p>
            <Link to={PageDefaultProfile} className='btn-outline-primary text-primary px-4 btn'>
              Go Home
            </Link>
          </div>

          <Image src={imgBanner} fluid className='w-50' />
        </div>
      </div>
    </Container>
  )
}
